import { render, staticRenderFns } from "./NotificationLogDialog.vue?vue&type=template&id=58a65da4&scoped=true"
import script from "./NotificationLogDialog.vue?vue&type=script&lang=js"
export * from "./NotificationLogDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationLogDialog.vue?vue&type=style&index=0&id=58a65da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a65da4",
  null
  
)

export default component.exports